import { Col, Row } from "antd";
import usePageTitle from "../../core/hooks/usePageTitle";
import ClienteLista from "../features/ClienteLista";
import useBreadcrumb from "../../core/hooks/useBreadcrumb";

export default function ClienteListaView() {
  usePageTitle("Consulta de cliente");
  useBreadcrumb("Cliente/Consulta");

  return (
    <Row>
      <Col xs={24}>
        <ClienteLista />
      </Col>
    </Row>
  );
}
